<template>
	<b-container class='report-page'>
            <b-row>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('omitted_stops_report.block') }}</label>
                        <vSelect :options="blockOptions" v-model="selectedBlock" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('omitted_stops_report.line') }}</label>
                        <!-- vSelect :options="lineOptions" v-model="selectedLine" label="tunnusteksti" :reduce="line => line.tunnus" / -->
                        <vSelect :options="lineOptions" v-model="selectedLine" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('omitted_stops_report.start_date') }}</label>
                        <b-form-datepicker 
                            :placeholder="this.$t('datepicker.labelNoDateSelected')"
                            v-model="selectedStartDate"
                            :locale="this.$t('datepicker.locale')" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }" >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <label>{{ $t('omitted_stops_report.end_date') }}</label>
                        <b-form-datepicker 
                            :placeholder="this.$t('datepicker.labelNoDateSelected')"
                            v-model="selectedEndDate"
                            :locale="this.$t('datepicker.locale')" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }" >
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class='btn-row'>
                <b-col>
                    <b-button class="btn-success btn-report" @click="generateReport()" :disabled="buttonDisabled">
                        <b-icon icon="arrow-clockwise" scale="1.2"></b-icon>
                        {{ $t('report.generate') }}
                    </b-button>
                    <b-button class="btn-success btn-report" @click="printReport()" :disabled="buttonDisabled || !generated">
                        <b-icon icon="printer" scale="1.2"></b-icon>
                        {{ $t('report.print') }}
                    </b-button>
                    <b-button class="btn-success btn-report" @click="generateXLS()" :disabled="buttonDisabled || !generated">
                        <b-icon icon="download" scale="1.2"></b-icon>
                        {{ $t('report.download') }}
                    </b-button>
                </b-col>  
            </b-row>
			<b-row>
				<b-col>
                    <b-table
						striped
						hover
						:items="items"
						:fields="fields"
						:per-page="perPage"
						:current-page="currentPage"
                        :busy="loading">
                        
                    <template #table-busy>
                        <Loading />
                    </template>
					
                    <!--
                    <template v-slot:cell(deviation)="row">
                        {{ getDeviation(row.item.departureTime, row.item.realTime) }}
                    </template>
                    -->
                    <template v-slot:cell(actions)="row">
                        <b-button size="sm" @click="row.toggleDetails">{{ row.detailsShowing ? '-' : '+' }}</b-button>
                    </template>

                    <template v-slot:row-details="row">
                        <b-card>
                            <!-- b-table :items="row.item.passings" :fields="stopListFields">
                                <template v-slot:cell(deviation)="row">
                                    {{ getDeviation(row.item.passingTime, row.item.realTime) }}
                                </template>
                            </b-table -->

                            <b-container>
                                <b-row>
                                    <b-col>{{ $t('omitted_stops_report.order') }}</b-col>
                                    <b-col>{{ $t('omitted_stops_report.stop') }}</b-col>
                                    <b-col>{{ $t('omitted_stops_report.scheduled_time') }}</b-col>
                                    <b-col>{{ $t('omitted_stops_report.real_time') }}</b-col>
                                    <b-col>{{ $t('omitted_stops_report.deviation') }}</b-col>
                                </b-row>
                                <b-row v-for="passing in row.item.passings" :key="passing.stop+'_'+passing.realTime"
                                    style="border-top: 1px solid; padding-top: 3px">
                                    <b-col>{{ passing.stopOrder }}</b-col>
                                    <b-col>{{ passing.stopName ? passing.stop +' '+ passing.stopName : passing.stop }}</b-col>
                                    <b-col>{{ formatTime(passing.passingTime, 'HH:mm') }}</b-col>
                                    <b-col>{{ formatTime(passing.realTime, 'HH:mm:ss') }}</b-col>
                                    <b-col>{{ getDeviation(passing.passingTime, passing.realTime) }}</b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </template>
					</b-table>

					<TablePagination
						:total-rows="totalRows"
						:per-page="perPage"
						@pageChange="onPageChange"
					>
					</TablePagination>
				</b-col>
			</b-row>
	</b-container>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination';
import punctualityReport from '@/store/realtime/punctualityReport';
import omittedStopsReport from '@/store/realtime/omittedStopsReport';
import vSelect from 'vue-select'
import moment from 'moment';

export default {
	components: { TablePagination, vSelect },
	data: function() {
		return {
			perPage: 30,
			currentPage: 1,
            availableLines: [],
            selectedBlock: null,
            selectedLine: null,
            selectedStartDate: new moment().format('YYYY-MM-DD'),
            selectedEndDate: new moment().format('YYYY-MM-DD'),
            loading: false,
            generated: false,
            printing : false
		};
	},
	computed: {
		fields() {
            return [
                //{ key: 'block', label: this.$t('punctuality_report.block'), sortable: true },
				{ key: 'line', label: this.$t('omitted_stops_report.line'), sortable: true },
				{ key: 'departureTime', label: this.$t('omitted_stops_report.departure_time'), sortable: true,
                    formatter: function(value) {
                        var time = new moment(value, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
                        if (time.startsWith('Invalid')) {
                            return '';
                        }
                        return time;
                    }
                },
				{ key: 'omittedStops', label: this.$t('omitted_stops_report.omitted_stops'), sortable: true },
                { key: 'actions', label: '' }
            ];
        },
		items() {
			return this.$store.state.omittedStopsReport.omittedStopsReportList;
		},
        blockOptions() {
            return this.$store.state.punctualityReport.availableBlocks;
        },
        lineOptions() {
            return this.availableLines;
        },
        buttonDisabled() {
            return !this.selectedLine || !this.selectedStartDate || !this.selectedEndDate || this.loading || this.printing;
        },
		totalRows() {
			return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
		},
	},
    watch: {
        selectedBlock() {
            this.selectedLine = null;
            if (this.selectedBlock) {
                this.availableLines = this.$store.state.punctualityReport.availableLineNumbersByBlock[this.selectedBlock];
            } else {
                this.availableLines = this.$store.state.punctualityReport.availableLineNumbers;
            }
        }
    },
    beforeCreate() {
		if (!this.$store.state.punctualityReport) {
            this.$store.registerModule("punctualityReport", punctualityReport);
        }
        this.$store.dispatch('punctualityReport/getAvailableBlocks');
        this.$store.dispatch('punctualityReport/getAvailableLineNumbers');
        this.$store.dispatch('punctualityReport/getAvailableLineNumbersByBlock');
        if (!this.$store.state.omittedStopsReport) {
            this.$store.registerModule("omittedStopsReport", omittedStopsReport);
        }
	},
    created() {
        this.availableLines = this.$store.state.punctualityReport.availableLineNumbers;

        window.addEventListener("afterprint", this.afterprint);
    },
    beforeDestroy(){
        window.removeEventListener("afterprint", this.afterprint);
    },
	methods: {
		onPageChange(page) {
			this.currentPage = page;
		},
        generateReport() {
            this.loading = true;

            var startTime = new moment(this.selectedStartDate, 'YYYY-MM-DD');
            var endTime = new moment(this.selectedEndDate, 'YYYY-MM-DD');
            endTime.add(1, 'd');
            var params = {
                'line': this.selectedLine,
                'startTime': startTime.format('YYYY-MM-DD[T]HH:mm:ssZZ'),
                'endTime': endTime.format('YYYY-MM-DD[T]HH:mm:ssZZ'),
                'minEarly': this.minEarly,
                'minLate': this.minLate
            }
            this.$store.dispatch('omittedStopsReport/getOmittedStopsReportList', params)
                .finally(() => { this.loading = false; this.generated = true });
        },
        generateXLS() {
            this.loading = true;

            var startTime = new moment(this.selectedStartDate, 'YYYY-MM-DD');
            var endTime = new moment(this.selectedEndDate, 'YYYY-MM-DD');
            endTime.add(1, 'd');
            var params = {
                'line': this.selectedLine,
                'startTime': startTime.format('YYYY-MM-DD[T]HH:mm:ssZZ'),
                'endTime': endTime.format('YYYY-MM-DD[T]HH:mm:ssZZ'),
                'minEarly': this.minEarly,
                'minLate': this.minLate,
                'header1': this.$t('omitted_stops_report.line'),
                'header2': this.$t('omitted_stops_report.departure_time'),
                'header3': this.$t('omitted_stops_report.order'),
                'header4': this.$t('omitted_stops_report.stop'),
                'header5': this.$t('omitted_stops_report.scheduled_time'),
                'header6': this.$t('omitted_stops_report.real_time'),
                'header7': this.$t('omitted_stops_report.deviation')
            }
            this.$store.dispatch('omittedStopsReport/exportXLS', params)
                .finally(() => { this.loading = false; });
        },
        getDeviation(scheduledTime, realTime) {
            if (!scheduledTime || !realTime) {
                return '';
            }
            var scheduled = new moment(scheduledTime, 'YYYY-MM-DD[T]HH:mm:ssZZ');
            var real = new moment(realTime, 'YYYY-MM-DD[T]HH:mm:ssZZ');
            var deviation = new moment.duration(real.diff(scheduled)).asMilliseconds();
            if (deviation >= 0) {
                return new moment.utc(deviation).format('[+]HH:mm:ss');
            }
            return new moment.utc(new moment.duration(scheduled.diff(real)).asMilliseconds()).format('[-]HH:mm:ss');
        },
        formatTime(time, format) {
            var formatted = new moment(time, 'YYYY-MM-DD[T]HH:mm:ssZZ').format(format);
            if (formatted.startsWith('Invalid')) {
                return '';
            }
            return formatted;
        },
        printReport(){
            this.printing = true;
            this.perPage = this.items.length
            // timeout needed because table takes some time to render
            setTimeout(() => { window.print(); }, 10);   
        },
        afterprint(){
            this.perPage = 30;
            this.printing = false;
        }
	}
};
</script>